/**
 * IPFS URL utilities for gateway fallback.
 */

export function isIpfsUrl(url: string): boolean {
  return url.includes('/ipfs/');
}

export function extractIpfsCid(url: string): string | null {
  const match = url.match(/\/ipfs\/([^/?#]+)/);
  return match ? match[1] : null;
}

export function getAlternateGateways(originalUrl: string): string[] {
  const cid = extractIpfsCid(originalUrl);
  if (!cid) return [];

  let originalHost: string;
  try {
    originalHost = new URL(originalUrl).host;
  } catch {
    return [];
  }

  const gateways = [
    `https://dweb.link/ipfs/${cid}`,
    `https://ipfs.io/ipfs/${cid}`,
  ];

  return gateways.filter((g) => !g.includes(originalHost));
}
